import React from "react";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import NotFound from "components/NotFound";

import List from "components/Captcha/List";

const mapStateToProps = state => ({
    ...state.admin,
});

const mapDispatchToProps = dispatch => ({});

class Captcha extends React.Component {
    render() {
        const { match } = this.props;
        const basepath = match.path === "/" ? "" : match.path;

        return (
            <Switch>
                <Route exact path={`${basepath}/`} component={List} />
                <Route exact component={NotFound} />
            </Switch>
        );
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Captcha);
